import { BreakpointActions, QuizDataInput } from '@naturalcycles/shared'
import { birthControlMethod } from '@src/app/constants/breakpoints/birth-control-method.js'
import { conceiveTiming } from '@src/app/constants/breakpoints/conceive-timing.js'
import { cycleChanges } from '@src/app/constants/breakpoints/cycle-changes.js'
import { goalBreakpoint } from '@src/app/constants/breakpoints/goal.js'
import { hormonalBirthControlUsage } from '@src/app/constants/breakpoints/hormonal-birth-control-usage.js'
import { sideEffects } from '@src/app/constants/breakpoints/side-effects.js'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { Breakpoint } from '@src/app/shared/typings/enum/quiz.js'
import { BreakpointOption } from '@src/app/shared/typings/interfaces/quiz.js'
import { eligibleAppleWatch } from './breakpoints/eligible-apple-watch.js'
import { feelingStressed } from './breakpoints/feeling-stressed.js'
import { hormonalBirthControlHowLong } from './breakpoints/hormonal-birth-control-how-long.js'
import { medicalConditions } from './breakpoints/medical-conditions.js'
import { nightSleep } from './breakpoints/night-sleep.js'
import { periodTrackerUsage } from './breakpoints/period-tracker-usage.js'
import { sleepWearable } from './breakpoints/sleep-wearable.js'
import { whichWearable } from './breakpoints/which-wearable.js'

export const breakpointActions: BreakpointActions<
  Breakpoint,
  BreakpointOption,
  Page,
  QuizDataInput
> = {
  [Breakpoint.goal]: goalBreakpoint, // common
  [Breakpoint.birthControlMethod]: birthControlMethod, // prevent
  [Breakpoint.sideEffects]: sideEffects, // prevent
  [Breakpoint.conceiveTiming]: conceiveTiming, // plan
  [Breakpoint.hormonalBirthControlUsage]: hormonalBirthControlUsage, // plan
  [Breakpoint.hormonalBirthControlHowLong]: hormonalBirthControlHowLong, // common
  [Breakpoint.medicalConditions]: medicalConditions, // common
  [Breakpoint.periodTrackerUsage]: periodTrackerUsage, // common
  [Breakpoint.cycleChanges]: cycleChanges, // common
  [Breakpoint.whichWearable]: whichWearable, // common
  [Breakpoint.eligibleAppleWatch]: eligibleAppleWatch, // common
  [Breakpoint.sleepWearable]: sleepWearable, // common
  [Breakpoint.nightSleep]: nightSleep, // common
  [Breakpoint.feelingStressed]: feelingStressed, // common
}
